import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import DefaultLayout from '../layouts/Default.vue';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
    // TODO setup url redirect in CDN so all /map routes point to /
    {
        path: '/',
        name: 'Home',
        component: DefaultLayout,
    },
    {
        path: '/map',
        name: 'Home',
        component: DefaultLayout,
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router;
